import SyncReportModal from './SyncReportModal';

export default SyncReportModal;
